const ROUTES = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  LOCK: '/auth/lock',
  FORGOTPWD: '/auth/forgotPwd',
  RESETPWD: '/auth/reset-password/:token',

  ROOT: '/',
  DASHBOARD: '/',
  PROFILE: '/profile',

  PROPERTIES: '/properties',
  ADD_PROPERTY: '/properties/create',
  EDIT_PROPERTY: '/properties/:slug/edit',

  AGENTS: '/agents',
  ADD_AGENT: '/agents/create',
  EDIT_AGENT: '/agents/:id/edit',

  WAREHOUSE: '/warehouse',
  ADD_WAREHOUSE: '/warehouse/create',
  EDIT_WAREHOUSE: '/warehouse/:slug/edit',

  BRANDS: '/brands',
  ADD_BRAND: '/brands/create',
  EDIT_BRAND: '/brands/:id/edit',

  CATEGORIES: '/categories',
  ADD_CATEGORY: '/categories/create',
  EDIT_CATEGORY: '/categories/:id/edit',

  PRODUCTS: '/products',
  ADD_PRODUCT: '/products/create',
  EDIT_PRODUCT: '/products/:slug/edit',

  BLOGS: '/blogs',
  ADD_BLOG: '/blogs/create',
  EDIT_BLOG: '/blogs/:slug/edit',

  PROPERTY_PERFORMANCE: '/propertyPerformance',
  ADD_PROPERTY_PERFORMANCE: '/propertyPerformance/create',
  EDIT_PROPERTY_PERFORMANCE: '/propertyPerformance/:id/edit',

  PERFORMANCE_GROWTH: '/performanceGrowth',
  ADD_PERFORMANCE_GROWTH: '/performanceGrowth/create',
  EDIT_PERFORMANCE_GROWTH: '/performanceGrowth/:id/edit',

  DATA_DRIVEN_INTELLIGENCE: '/dataDrivenIntelligence',
  ADD_DATA_DRIVEN_INTELLIGENCE: '/dataDrivenIntelligence/create',
  EDIT_DATA_DRIVEN_INTELLIGENCE: '/dataDrivenIntelligence/:id/edit',

  PROPERTYTYPES: '/propertyTypes',
  ADD_PROPERTYTYPE: '/propertyType/create',
  EDIT_PROPERTYTYPE: '/propertyType/:id/edit',

  PROPERTYCATEGORIES: '/propertyCategories',
  ADD_PROPERTYCATEGORY: '/propertyCategory/create',
  EDIT_PROPERTYCATEGORY: '/propertyCategory/:id/edit',

  PROPERTYAMENITIES: '/propertyAmenities',
  ADD_PROPERTYAMENITY: '/propertyAmenity/create',
  EDIT_PROPERTYAMENITY: '/propertyAmenity/:id/edit',

  JOBS: '/jobs',
  ADD_JOB: '/job/create',
  EDIT_JOB: '/job/:slug/edit',

  DEVELOPERS: '/developers',
  ADD_DEVELOPER: '/developer/create',
  EDIT_DEVELOPER: '/developer/:slug/edit',

  MARKETPLACES: '/marketPlaces',
  ADD_MARKETPLACE: '/marketPlace/create',
  EDIT_MARKETPLACE: '/marketPlace/:id/edit',

  AREAS: '/areas',
  ADD_AREA: '/area/create',
  EDIT_AREA: '/area/:slug/edit',

  PROJECTS: '/projects',
  ADD_PROJECT: '/project/create',
  EDIT_PROJECT: '/project/:slug/edit',

  FLOORS: '/floors',
  ADD_FLOOR: '/floor/create',
  EDIT_FLOOR: '/floor/:id/edit',

  LOCATIONS: '/locations',
  ADD_LOCATION: '/location/create',
  EDIT_LOCATION: '/location/:id/edit',

  PROPERTY_GUIDES: '/propertyGuides',
  ADD_PROPERTY_GUIDE: '/propertyGuide/create',
  EDIT_PROPERTY_GUIDE: '/propertyGuide/:id/edit',

  PODCASTS: '/podcasts',
  ADD_PODCAST: '/podcast/create',
  EDIT_PODCAST: '/podcast/:id/edit',

  TESTIMONIALS: '/testimonials',
  ADD_TESTIMONIAL: '/testimonial/create',
  EDIT_TESTIMONIAL: '/testimonial/:slug/edit',

  SEO: '/seo',
  ADD_SEO: '/seo/create',
  EDIT_SEO: '/seo/:id/edit',

  REVIEW: '/reviews',
  ADD_REVIEW: '/review/create',
  EDIT_REVIEW: '/review/:id/edit',

  MARKETINSIGHT: '/marketInsight',
  ADD_MARKETINSIGHT: '/marketInsight/create',
  EDIT_MARKETINSIGHT: '/marketInsight/:id/edit',

  REPORT: '/report',
  ADD_REPORT: '/report/create',
  EDIT_REPORT: '/report/:id/edit',

  FAQ: '/faq',
  ADD_FAQ: '/faq/create',
  EDIT_FAQ: '/faq/:id/edit',

  JOBREQUEST: '/job-requests',
  ENQUIRIES: '/enquiries',
  PROPERTYVALUE: '/property-value',

  CTA: '/cta',
  LEADS: '/leads',
  TRADE_ACCOUNTS: '/trade-accounts',

  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',

  PAYMENT_LINKS: '/payment-links',
  ADD_PAYMENT_LINK: '/payment-links/create',

  INSIGHTS: '/insights',
  ADD_INSIGHT: '/insights/create',
  EDIT_INSIGHT: '/insights/:slug/edit',

  VERIFY_EMAIL: '/verify-email/:token',

  CMS: '/cms/:code',

  SETTINGS_GENERAL: '/settings/general',

};

export default ROUTES;
